import { memo, useCallback, useEffect, useMemo, useState } from "react"
import { useLocation } from "react-router-dom"
import styled from "@emotion/styled"
import { useSearchAction } from "@/features/useSearchAction"
import { formatCurrency } from "@/utils/format"
import { useModalSlideUp } from "@/features/useModal"
import ButtonRegular from "@/components/composite/ButtonRegular/main"
import InputMoneyText from "@/components/form_item/InputMoneyText"
import { useForm, FormProvider } from "react-hook-form"
import ModalSlideUp from "@/components/composite/ModalSlideUp/main"
import SelectAccountType from "@/pages/WithdrawAccounts/components/SelectAccountType"
import SelectWithdrawAccount from "./SelectWithdrawAccount"
import { withDraw as withDrawApi } from "@/features_signal/withdrawAccounts/withdraw"
import { fetchAccounts, accounts } from "@/features_signal/withdrawAccounts/fetchAccounts"
import { resolveAssetImage } from "@/utils/common"
import { ACCOUNT_TYPE, WITHDRAW_ACCOUNT } from "@/pages/WithdrawAccounts/constants"
import Svg, { SvgComponent } from "@/components/base/Svg"
import AccountCard from "./AccountCard"
import { fetchFinanceChannelList, channelList } from "@/features_signal/channels/fetchChannels"
import Wallet from "@/features_signal/wallet"
import { useGetState } from "ahooks"
import { computed } from "@preact/signals"
import AppSignals from "@/features_signal/app"
import { toast } from "react-toastify"

const WithdrawContainer = styled.div`
    position: relative;
    background-color: rgba(242, 243, 245, 1);
    display: flex;
    flex-direction: column;
    align-items: stretch;
`
const WithdrawContent = styled.div`
    margin: 12rem 12rem;
`

const WithdrawTitle = styled.div`
    display: flex;
    justify-content: center;
    font-weight: 500;
    font-size: 18rem;
    padding-top: 8rem;
    height: 72rem;
    letter-spacing: 0%;
    text-align: center;
    color: rgba(255, 255, 255, 0.95);
    margin-top: -12rem;
    position: relative;
    & > img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
    }
    & > span {
        position: relative;
    }
`

const OptionClose = styled(SvgComponent("pages/UserCenterPage/deposit/close.svg"))`
    width: 24rem;
    height: 24rem;
    position: absolute;
    top: 12rem;
    right: 12rem;
    cursor: pointer;
`

const WithdrawCard = styled.div`
    background-color: #ffffff;
    border-radius: 10rem;
    border: 1rem solid #ffffff;
    padding: 12rem;
    margin-bottom: 12rem;
`

const WithdrawCardTitle = styled.p`
    color: #131416;
    font-size: 16rem;
    font-weight: 500;
    line-height: 24rem;
    padding: 0;
    margin: 0 0 6rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > span:nth-child(2) {
        color: #054bf0;
        font-size: 14rem;
    }
`
const WithdrawHint = styled.p`
    color: #69728c;
    font-size: 12rem;
    font-weight: 400;
    line-height: 16rem;
    padding: 0;
    margin: 0;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    hyphens: auto;
`

const CardAccountHint = styled.p`
    font-size: 12rem;
    font-weight: 400;
    font-family: "Gilroy";
    margin: 12rem 0 0;
    display: flex;
    align-items: center;
    & > span:nth-child(1) {
        color: #69728c;
        margin-right: 6rem;
    }
    & > span:nth-child(2) {
        color: #131416;
        font-weight: 400;
        margin-right: 6rem;
    }
    & > img {
        width: 16rem;
        height: 16rem;
    }
`
const CardAccountHintSvg = styled(SvgComponent("pages/UserCenterPage/withdraw/doubt.svg"))`
    width: 16rem;
    height: 16rem;
`
const BottomBlock = styled.div`
    padding: 12rem 12rem 32rem;
    position: sticky;
    bottom: 0;
    left: 0;
`
const AccountCardUnSelected = styled.div`
    border: 1rem dashed #ff1f57;
    height: 80rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: 8rem;

    & > span {
        position: absolute;
        bottom: 16rem;
        color: #ff356b;
        font-weight: 400;
        font-size: 14rem;
        line-height: 20rem;
        transform: translateY(50%);
    }
`
interface MoneyProps {
    isMaya?: boolean
    isActive?: boolean
}

const AccountTitle = styled.div`
    color: var(--Text-regular-light-weakened, rgba(0, 0, 0, 0.55));
    /* Main body/regular/M */
    font-family: "Gilroy";
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
`
const AccountSpan = styled.span`
    color: var(--Text-regular-light-main, rgba(0, 0, 0, 0.95));
    /* Main body/medium/M */
    font-family: "Gilroy";
    font-size: 14rem;
    font-style: normal;
    font-weight: 500;
    margin-left: 4rem;
`

const MoneyNumList = styled.div<MoneyProps>`
    display: flex;
    flex-wrap: ${(props) => (props.isMaya ? "wrap" : "nowrap")};
    overflow-x: auto;
    gap: ${(props) => (props.isMaya ? "5rem" : "8rem;")};
    white-space: nowrap;
    padding-top: 16rem;
    padding-bottom: ${(props) => (props.isMaya ? "20rem" : "0;")};
    &::-webkit-scrollbar {
        height: 0;
        background: transparent;
        opacity: 0; /* 默认隐藏 */
    }
`
const MoneyBlock = styled.div<MoneyProps>`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props) => (props.isMaya ? "105rem" : "78rem")};
    height: ${(props) => (props.isMaya ? "48rem" : "40rem")};
    line-height: ${(props) => (props.isMaya ? "48rem" : "40rem")};
    text-align: center;
    border-radius: 6rem;
    background: ${(props) => (props.isActive ? "#ffffff" : "#f2f3f5")};
    color: ${(props) => (props.isActive ? "#FB517B" : "#40444f")};
    border: ${(props) =>
        props.isActive ? "1px solid var(--primary-light-primary-5, #FB517B);" : "none"};
    cursor: pointer;
    font-weight: 400;
    font-size: 16rem;
`
const AccountCardSvg = styled(SvgComponent("pages/UserCenterPage/withdraw/add.svg"))``

const SubmitButton = styled(ButtonRegular)`
    background: ${({ disabled }) =>
        disabled
            ? "linear-gradient(90deg, #FFADC2 0%, #FFADEB 100%)"
            : "linear-gradient(90deg, #FF3568 10%, #FF33CC 100%)"};

    width: 100%;
    height: 40rem;
    line-height: 40rem;
    font-family: "Gilroy";
    font-weight: 700;
    font-size: 16rem;
    text-align: center;
    color: ${({ disabled }) => (disabled ? "rgba(255, 255, 255, 1)" : "#ffffff")};
    box-shadow: none;
`
// eslint-disable-next-line react-refresh/only-export-components
export function formatThousandsIntl(num: string): string {
    try {
        return new Intl.NumberFormat("en-US").format(parseFloat(num))
    } catch {
        return num
    }
}

function Withdraw() {
    const location = useLocation()
    const enabledAccount = accounts.value?.filter((item) => item.status === 1) || []
    const [val, setVal] = useState<string>("")
    const { close } = useModalSlideUp("search-action")
    const { open: openModal } = useModalSlideUp("account-page")
    const { close: closeModalAddWithdrawAccount } = useModalSlideUp("add-withdraw-account")
    const [currentPayment, setCurrentPayment] = useState<
        FinanceAccountApiTypes.Fetcher.Response.Record | undefined
    >()

    const currentChannel = channelList.value?.find(
        (item) => item.name === currentPayment?.channel_name,
    )
    const isMayamini = computed(() => {
        return AppSignals.isMayaminiUser()
    })

    const isLazadamini = computed(() => {
        return AppSignals.isLazadaminiUser()
    })
    //mayamini 金额列表
    const amountLimit = computed(() => {
        if (isMayamini.value) {
            const mayaMini = channelList.value?.find((item) => item.name === "maya-mini")
            return mayaMini?.amount_limit ?? []
        } else if (isLazadamini.value) {
            const lazadaMini = channelList.value?.find((item) => item.name === "lazada-mini")
            return lazadaMini?.amount_limit ?? []
        }
    })

    console.log("amountLimit--------", amountLimit.value)

    const { min_amount, max_amount } = currentChannel || {}
    const isNullMinAmount = !min_amount || min_amount === ""
    useEffect(() => {
        setVal(val.replace(/[^\d]/g, ""))
    }, [val])

    useEffect(() => {
        if (enabledAccount.length > 0) {
            // 遍历enabledAccount，根据channel_name选择账户
            const mayaMiniIndex = enabledAccount.findIndex(
                (account) => account.channel_name === "maya-mini",
            )
            const lazadaMiniIndex = enabledAccount.findIndex(
                (account) => account.channel_name === "lazada-mini",
            )

            let selectedIndex = 0
            if (isMayamini.value) {
                selectedIndex = mayaMiniIndex
            } else if (isLazadamini.value) {
                selectedIndex = lazadaMiniIndex
            }

            setCurrentPayment(enabledAccount[selectedIndex])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accounts.value])

    const { clearAction } = useSearchAction()
    const methods = useForm({
        defaultValues: {
            amount: "",
        },
    })

    const { setValue, getValues, formState } = methods
    const { errors } = formState
    const isHasError = Object.keys(errors).length > 0

    const handleClose = useCallback(async () => {
        await closeModalAddWithdrawAccount()
        await close()
        await clearAction()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleCloseWithdrawAccount = async () => {
        close()
    }

    const handleOpenModal = useCallback(
        (type: string) => {
            switch (type) {
                case "accountType":
                    openModal(
                        <SelectAccountType
                            accounts={enabledAccount}
                            channels={channelList.value || []}
                        />,
                        {
                            closeOnClickMask: true,
                            closeOnEscape: false,
                            // onClose: handleClose,
                        },
                    )
                    close()
                    break
                case "withdrawAccount":
                    openModal(
                        <SelectWithdrawAccount
                            accounts={enabledAccount}
                            selectedAccount={currentPayment}
                            onSelect={setCurrentPayment}
                            channels={channelList.value || []}
                        />,
                        {
                            closeOnClickMask: false,
                            closeOnEscape: false,
                        },
                    )
                    break
                default:
                    break
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [openModal, enabledAccount, currentPayment],
    )

    const [isSubmitting, setIsSubmitting, getIsSubmitting] = useGetState(false)

    const handleSubmit = useCallback(async () => {
        const amount = getValues("amount")

        try {
            if (!amount || getIsSubmitting()) return

            setIsSubmitting(true)

            const data = {
                account_id: currentPayment?.id,
                amount,
            }

            await withDrawApi(data)
            await handleClose()
            await Wallet.fetchWallet()
        } catch (err) {
            console.error(err)
            toast.error(err instanceof Error ? err.message : String(err))
        } finally {
            setIsSubmitting(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPayment])

    const withdrawable = computed(() =>
        Wallet.wallet.value?.withdrawable
            ? parseFloat(Wallet.wallet.value.withdrawable).toFixed(2)
            : 0,
    )

    useEffect(() => {
        Wallet.fetchWallet()
        fetchAccounts()
        fetchFinanceChannelList("2")
    }, [])

    // 格式化余额
    const formattedBalance = formatCurrency(withdrawable.value, {
        currency: "PHP",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })

    const SelectAmount = async (amount: string) => {
        if (Number(withdrawable.value) > Number(amount)) {
            setVal(amount)
            setValue("amount", amount)
        }
    }

    return (
        <>
            <WithdrawContainer>
                <WithdrawTitle>
                    <img
                        src={resolveAssetImage("pages/UserCenterPage/deposit/deposit_head.webp")}
                        alt="header"
                    />
                    <span>Withdraw</span>
                </WithdrawTitle>
                <OptionClose onClick={handleCloseWithdrawAccount}></OptionClose>
                <WithdrawContent>
                    {isMayamini.value || isLazadamini.value ? (
                        ""
                    ) : (
                        <WithdrawCard>
                            <WithdrawCardTitle>
                                <span>Withdraw Account</span>
                                {enabledAccount?.length > 0 && (
                                    <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleOpenModal(WITHDRAW_ACCOUNT)}
                                    >
                                        Change
                                    </span>
                                )}
                            </WithdrawCardTitle>
                            {enabledAccount?.length > 0 && (
                                <AccountCard
                                    data={currentPayment}
                                    channel={currentChannel}
                                />
                            )}
                            {enabledAccount?.length === 0 && (
                                <AccountCardUnSelected
                                    onClick={() => handleOpenModal(ACCOUNT_TYPE)}
                                >
                                    <AccountCardSvg />
                                    <span>Add Withdraw account</span>
                                </AccountCardUnSelected>
                            )}
                        </WithdrawCard>
                    )}
                    <WithdrawCard>
                        {isMayamini.value || isLazadamini.value ? (
                            <>
                                <AccountTitle>
                                    Withdraw to account:{" "}
                                    <AccountSpan>{currentPayment?.id}</AccountSpan>
                                </AccountTitle>
                                <MoneyNumList
                                    isMaya={
                                        isMayamini.value ? isMayamini.value : isLazadamini.value
                                    }
                                >
                                    {amountLimit.value?.map((moneyItem, index) => (
                                        <MoneyBlock
                                            key={`${index}_fast_sel_amount`}
                                            isActive={val === moneyItem}
                                            isMaya={
                                                isMayamini.value
                                                    ? isMayamini.value
                                                    : isLazadamini.value
                                            }
                                            onClick={() => SelectAmount(moneyItem)}
                                        >
                                            {formatThousandsIntl(moneyItem)}
                                        </MoneyBlock>
                                    ))}
                                </MoneyNumList>
                            </>
                        ) : (
                            <WithdrawCardTitle>Withdraw Amount</WithdrawCardTitle>
                        )}

                        <FormProvider {...methods}>
                            <InputMoneyText
                                fieldName={"amount"}
                                placeholder={
                                    isNullMinAmount
                                        ? "Enter Amount"
                                        : "Minimum Amount: " + min_amount
                                }
                                iconSrc={<Svg src="pages/UserCenterPage/deposit/peso.svg" />}
                                min={Number(min_amount) || undefined}
                                max={Number(max_amount) || undefined}
                                customText={"Withdraw All"}
                                customOnClick={() => {
                                    setValue("amount", withdrawable.value || "0")
                                }}
                            />
                        </FormProvider>
                        <CardAccountHint>
                            <span>Withdrawable balance:</span>
                            <span>{formattedBalance}</span>
                            <CardAccountHintSvg />
                        </CardAccountHint>
                    </WithdrawCard>
                    {isMayamini.value ? (
                        ""
                    ) : (
                        <WithdrawHint lang="en">
                            Generally receive withdraw in 5 minutes; <br />
                            If your withdraw has not been received exceed 5 minutes, <br />
                            please contact customer service and provide your withdraw receipt.
                        </WithdrawHint>
                    )}
                </WithdrawContent>
                <BottomBlock>
                    <SubmitButton
                        disabled={isHasError || !currentPayment || isSubmitting}
                        onClick={handleSubmit}
                    >
                        Withdraw now
                    </SubmitButton>
                </BottomBlock>
            </WithdrawContainer>
            <ModalSlideUp familyName="account-page" />
        </>
    )
}

export default memo(Withdraw)
